module.exports = __webpack_public_path__ + "img/title.15daad09.png";